import React from 'react'

const TTD = ({ textToDonate }) =>
  <div className="overlay text-slightly-muted rounded-3 p-2">
    <h2 className="h5 mb-1 fw-normal">
      Text <span className="text-white">{textToDonate.keyword}</span>{' '}
      to <span className="text-white">{textToDonate.shortcode}</span>{' '}
      to donate
    </h2>

    <p className="mt-n2 mb-n1 text-slightly-muted">
      <small><small><small>
        US only. Msg &amp; data rates may apply
      </small></small></small>
    </p>
  </div>

export default TTD
